require('./productTemplateBrowser.i18n.json');
require('./productTemplateBrowser.tpl.html');
require('./productTemplateBrowserActionRepository.js');
require('./productTemplateRepository.js');

/*@ngInject*/
const ProductTemplateBrowserController = function ($scope, $state, $filter, advancedFilterType, filterType, configurationMediator, configurationActionsUtil, localization, productTemplateAction, modalUtil, databaseDownloadSectionName) {

    localization.getTranslationByKey('productTemplateBrowser').then(function (translations) {

        $scope.columns = [{
            name: 'name',
            label: _.get(translations, 'columns.name'),
            className: 'colName',
            getValue: function (item) {
                return item.name;
            }
        }, {
            name: 'type',
            label: _.get(translations, 'columns.type'),
            className: 'colType',
            getValue: function (item) {
                let type;

                if (item.selectableOnQuote && item.selectableOnSubmission) {
                    type = 'both';
                } else if (item.selectableOnQuote) {
                    type = 'quote';
                } else {
                    type = 'submission';
                }

                return _.get(translations, 'type.' + type);
            }
        }, {
            name: 'status',
            label: _.get(translations, 'columns.status'),
            className: 'colStatus',
            getValue: function (item) {
                let status = item.active ? 'active' : 'inactive';

                return _.get(translations, 'status.' + status);
            }
        }, {
            name: 'lastModifiedBy',
            label: _.get(translations, 'columns.lastModifiedBy'),
            className: 'colLastModifiedBy',
            getValue: function (item) {
                return item.lastModifiedBy;
            }
        }, {
            name: 'timeLastModified',
            label: _.get(translations, 'columns.timeLastModified'),
            className: 'colTimeLastModified',
            getValue: function (item) {
                return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
            }
        }];

        $scope.advancedFilterType = advancedFilterType.PRODUCT_TEMPLATE_BROWSER;
        $scope.filterType = filterType.TYPE_PRODUCT_TEMPLATE_FILTER;

        $scope.stateParams = {
            browser: 'configuration.productTemplateBrowser',
            getDetailState: function (productTemplate) {
                return {
                    name: 'configuration.productTemplateEditor',
                    params: {
                        productTemplateName: productTemplate.name,
                        productTemplateId: productTemplate.id
                    }
                };
            }
        };

        $scope.translations = {
            title: _.get(translations, 'title'),
            recordCountText: _.get(translations, 'recordCountText'),
            recordsCountText: _.get(translations, 'recordsCountText'),
            emptyGrid: _.get(translations, 'emptyGrid')
        };

        $scope.initialRequestParams = {
            key: 'name',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc'
        };

        $scope.loadActionsHandler = function () {
            return configurationMediator.loadProductTemplateActions();
        };

        $scope.loadItemsHandler = function (filterUri, requestParams) {
            return configurationMediator.getProductTemplatesByFilterUri(filterUri, requestParams);
        };

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case productTemplateAction.NEW_PRODUCT_TEMPLATE:
                        $state.go('configuration.productTemplateEditor');
                        break;

                    case productTemplateAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.PRODUCT_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };
    });
};

angular.module('ums.configuration')
    .controller('productTemplateBrowserController', ProductTemplateBrowserController);
